/* globals require */
import jQuery from 'jquery';
window.jQuery = jQuery;
window.$ = jQuery;

import angular from 'angular';
require('ngreact');

import ngSanitize from 'angular-sanitize';
import ngAria from 'angular-aria';
import ngMaterial from 'angular-material';
import restangular from 'restangular';
import uiRouter from '@uirouter/angularjs';
import angularJwt from 'angular-jwt';
import ngTranslate from 'angular-translate';

/* eslint-disable @typescript-eslint/no-unused-vars */
import ngTranslateStorageLocal from 'angular-translate-storage-local';
import ngTranslateStorageCookie from 'angular-translate-storage-cookie';
import ngTranslateStaticFilesLoader from 'angular-translate-loader-static-files';
import uiBootstrap from 'angular-ui-bootstrap';
import uiSortable from 'angular-ui-sortable';
import uiSelect from 'ui-select';
import uiValidate from 'angular-ui-validate';
import tmhDynamicLocale from 'angular-dynamic-locale';
import angularLocalStorage from 'angular-local-storage';

import "jquery-flot";
import "jquery-flot/jquery.flot.categories";
import "jquery-flot/jquery.flot.pie";
import "jquery-flot/jquery.flot.time";
import "flot-axislabels";
import "jquery.flot.tooltip";
import "../thirdparty/flot/jquery.flot.resize.fides";

import ngFlot from 'angular-flot';

import "../thirdparty/jquery.jvectormap/jquery-jvectormap-2.0.3.min.js";
import "../thirdparty/jquery.jvectormap/jvectormap-world-mill.js";
import "../thirdparty/jquery.jvectormap/jquery-jvectormap-us-aea.js";
import "../thirdparty/jquery.jvectormap/jquery-jvectormap-de-mill.js";
import "../thirdparty/jquery.jvectormap/jquery-jvectormap-ch-mill.js";

import ngStorage from 'angular-storage';
import ftsComponents from 'fides-angularjs-components/src';
import { arsMainDependencies } from './utils/ars.main.dependencies';
import { config } from './index.config';
import { routerConfig } from './index.route';
import { Directives } from './components/directives';
import { Controllers } from './controller/controllers';
import { fsHeatmapDirective } from './components/heatmap/component';
import { AccountService } from './services/AccountService';
import { BackendService } from './services/BackendService';
import { CurrencyService } from './services/CurrencyService';
import { CacheBusterService } from './services/CacheBusterService';
import { FlotService } from './services/FlotService';
import { ArsConfig } from './config/arsConfig.factory';
import { fsLoginController } from './views/login/login';
import { ApplicationInformation } from 'fides-angularjs-components/src/fts-application';
import "angular-scalyr";

import * as d3 from "d3";

/*
import "../thirdparty/jquery.ui/jquery-ui.min.js";
import "../thirdparty/sortable/sortable.js";
*/
import { runBlock } from './index.run';

import { ReactComponents } from "./components/reactComponents";
import notFoundTemplate from './views/layout/404.html';

const isIE = window.document.documentMode;

let arswebModule = angular.module('arsweb', [
	ngSanitize,
	ngAria,
	restangular,
    uiRouter,
	angularJwt,
	ngTranslate,
	'ui.bootstrap',
	'ui.select',
    'ui.sortable',
	'ui.validate',
	tmhDynamicLocale,
	angularLocalStorage,
	ngMaterial,
	'angular-flot',
    ngStorage,
	'sly',
    ftsComponents,
    'react'
])

// Config
    .constant('applicationInformation', new ApplicationInformation('/arsweb', 'ARSWEB', 'en'))
	.config(config)
	.config(routerConfig)
	.constant('_', _)
    .factory('ArsConfig', ArsConfig)
    .factory('arsMainDependencies', arsMainDependencies)
	.directive('fsHeatmap', fsHeatmapDirective)
	.service('fsLoginController', fsLoginController)
    .service('flotService', FlotService)
	.service('accService', AccountService)
    .service('backendService', BackendService)
    .service('CurrencyService', CurrencyService)
	.service('CacheBusterService', CacheBusterService)
	.run(runBlock)
    // disable material animations
	.config(function($mdGestureProvider) {
        if (isIE) {
            $mdGestureProvider.disableAll();
        }
    })
    .config( function($mdInkRippleProvider) {
        if (isIE) {
            $mdInkRippleProvider.disableInkRipple();
        }
    })
	// While the OLD part must be working, the otherwise directive must be outside the routing and be added as last.
	.config(($stateProvider) => {
		$stateProvider.state('otherwise', {
			url: '*path',
			templateUrl: notFoundTemplate,
		});
	});

new Directives(arswebModule).defineDirectives();
new Controllers(arswebModule).defineControllers();
new ReactComponents(arswebModule).defineComponents();
